/* eslint-disable */
export default {
  title: '音频',
  dialButtonVolume: '拨号键音量',
  ringtoneVolume: '铃声音量',
  callVolume: '通话音量',
  muteCalls: '静音通话',
  outputDevice: '输出设备',
  inputDevice: '输入设备',
  micPermission: '麦克风权限',
  noDevice: '无设备',
  checkMicPermission: '检查权限',
  micNoPermissionMessage: '该应用没有使用麦克风的权限',
  noLabel: '未知设备',
  notSetSinkIdTip:
    '抱歉，当前的浏览器权限未设置为允许访问音频输出设备。{clickHereLink}以查看如何设置。',
  noLabelTip: '抱歉，当前的浏览器权限未设置为允许访问音频输入设备。',
  clickHere: '点击此处',
  defaultOutputDevice: '默认输出设备',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"dialButtonVolume"@#@ @source: @#@"Dial Button Volume"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone Volume"@#@
// @key: @#@"callVolume"@#@ @source: @#@"Call Volume"@#@
// @key: @#@"muteCalls"@#@ @source: @#@"Mute Calls"@#@
// @key: @#@"outputDevice"@#@ @source: @#@"Output Device"@#@
// @key: @#@"inputDevice"@#@ @source: @#@"Input Device"@#@
// @key: @#@"micPermission"@#@ @source: @#@"Microphone Permission"@#@
// @key: @#@"noDevice"@#@ @source: @#@"No device"@#@
// @key: @#@"checkMicPermission"@#@ @source: @#@"Check Permission"@#@
// @key: @#@"micNoPermissionMessage"@#@ @source: @#@"The app does not have permission to use microphone"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"notSetSinkIdTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio output devices. {clickHereLink} to see how to set up."@#@
// @key: @#@"noLabelTip"@#@ @source: @#@"Sorry, your current browser permissions aren't set to allow us to access your audio input devices."@#@
// @key: @#@"clickHere"@#@ @source: @#@"Click here"@#@
// @key: @#@"defaultOutputDevice"@#@ @source: @#@"Default output device"@#@
